<template>
  <a-modal
      :visible="roundingVisible"
      title="取整参数设置"
      @cancel="$emit('close')"
      width="800px"
      :footer="null"
      :bodyStyle="{ padding: '10px' }" :destroyOnClose="true"
      :forceRender="true"
  >
      <resize-table
          :scroll="{ x:400, y: 300 }"
          tableName="formulaRoundingColumns"
          :columns="columns"
          :data-source="data"
          :row-key="record => record.rawCode"
          :pagination="false"
          bordered
      >
      <!-- 取整系数 slot -->
      <template slot="fixRatio" slot-scope="text, record">
        <cell-editor :background="true" :item="record" :len="3" :name="'fixRatio'"
                     @blur="(target) => handleInput(target, record, 'fixRatio')" :text="text" :actions="update"/>
      </template>

      <!-- 最小称量量 slot -->
      <template slot="minWeightVal" slot-scope="text, record">
        <cell-editor :background="true" :name="'minWeightVal'" :item="record" :len="3"
                     @blur="(target) => handleInput(target, record, 'minWeightVal')" :text="text" :actions="update"/>
      </template>

        <template
            v-for="col in ['percentage','uasge']"
            slot-scope="text"
            :slot="col">
          <span :key="col">{{text || text === 0 ? text.toFixed(3) : text}}</span>
        </template>
    </resize-table>
  </a-modal>
</template>

<script>

import { nhfMixins } from '../../untils'
import CellEditor from "@/components/Nhf/Compound/editor/CellEditor.vue";

export default {
  components: {CellEditor},
  mixins: [nhfMixins],
  props: {
    roundingVisible: {
      type: Boolean,
      required: true,
    },
    formulaId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      columns: [
        {title: "原料名称", dataIndex: "rawName", key: "rawName"},
        {title: "代码", dataIndex: "rawCode", key: "rawCode"},
        {
          title: "取整系数(KG)",
          dataIndex: "fixRatio",
          key: "fixRatio",
          scopedSlots: {customRender: 'fixRatio'},
        },
        {
          title: "最小称量量(KG)",
          dataIndex: "minWeightVal",
          key: "minWeightVal",
          scopedSlots: {customRender: 'minWeightVal'}
        },
        {
          title: "用量(%)",
          dataIndex: "percentage",
          key: "percentage",
          scopedSlots: {customRender: 'percentage'}
        },
        {
          title: "用量(批次量)",
          dataIndex: "uasge",
          key: "uasge",
          scopedSlots: {customRender: 'uasge'}
        },
      ],
      data: [],
    };
  },
  watch: {
    roundingVisible(val) {
      if (val) {
        this.getFormulaRawFixRatioList();
      }
    },
  },
  methods: {
    async getFormulaRawFixRatioList() {
      try {
        const params = {
          factoryId: window.localStorage.getItem("factoryId"),
          formulaId: this.formulaId,
          staffId: window.localStorage.getItem("staffId"),
        };
        const res = await this.$http.post("/nhf-app/formulaNhf/formulaRawFixRatioList", params);
        if (res.success) {
          this.data = res.data || [];
        } else {
          this.$message.error(res.msg || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据时发生错误:", error);
        this.$message.error("请求失败，请稍后重试");
      }
    },
    handleInput(target, record, col) {
      // CellEditor组件返回的target包含完整的item对象，并且已更新了对应的值
      // 更新当前记录的值
      record[col] = target[col];
    },
    update(data) {
      // 构造请求参数
      const payload = {
        formulaRawVOList: [
          {
            factoryId: window.localStorage.getItem("factoryId"),
            formulaId: this.formulaId,
            fixRatio: data.fixRatio,
            minWeightVal: data.minWeightVal,
            rawId: data.rawId,
            id: data.id,
            staffId: window.localStorage.getItem("staffId"),
          },
        ],
      };
      // 调用后台接口更新数值
      return this.fetchPost({
        actions: this.updateRawFixRatioList,
        data: payload,
        showMessage: false,
      }).then(() => {
        //修改cacheList中的预计产量值
        this.data.forEach(item => {
          if (item.id === payload.id) {
            item.fixRatio = payload.fixRatio;
            item.minWeightVal = payload.minWeightVal;
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ant-table {
  tbody tr td {
    position: relative;
  }
}
</style>

<style scoped>
/* ... existing code ... */
</style>
